import { useConflictResolution } from "lib/@offline/conflict-dialog"
import { clearLocalDraft } from "lib/@offline/local-draft-store"
import { forceSyncDraft } from "lib/@offline/draft-sync-manager"
import { useCallback } from "react"

/**
 * Headless component mounted at the app root via RootPlugs.
 * Listens for DraftSyncConflict events from the background sync manager
 * and shows the conflict dialog so the user can choose to force-save or discard.
 */
export function BackgroundConflictHandler() {
    const handleForce = useCallback(async (event) => {
        if (!event?.key) return
        const saved = await forceSyncDraft(event.key)
        // If force-save can't run (no handler, timeout, etc.), keep the draft
        // so the user does not lose local work.
        if (!saved) {
            console.warn("Force-save did not complete; local draft preserved.")
        }
    }, [])

    const handleDiscard = useCallback(async (event) => {
        if (!event?.key) return
        await clearLocalDraft(event.key)
    }, [])

    useConflictResolution({ onForce: handleForce, onDiscard: handleDiscard })

    return null
}
